// components/RoundedComponents.js
import styled from 'styled-components';
import { Select, Input, Button, DatePicker, Tag, Col } from 'antd';
import NumberFormat from "react-number-format";

/* == Rounded Input == */
export const RoundedInput = styled(Input)`
  border-radius: 6px !important;
  height: ${({ height }) => height || '32px'};
  font-family: 'Rubik', sans-serif;
  ${({ uppercase }) => uppercase ? 'text-transform: uppercase;' : ''}

  .ant-input {
    ${({ uppercase }) => uppercase ? 'text-transform: uppercase;' : ''}
  }

  &[readonly] {
    background-color: #fafafa;
    color: #555;
    /* jangan pakai cursor: not-allowed, biarkan tetap text */
    cursor: text;
    pointer-events: none; /* ini bikin tidak bisa di-edit saat readonly */
  }
`;

export const RoundedNumberFormat = styled(NumberFormat)`
  border-radius: 6px !important;
  height: ${({ height }) => height || "32px"};
  font-family: "Rubik", sans-serif;
  text-align: right;
`;

/* == Rounded Button == */
export const RoundedButton = styled(Button)`
  border-radius: 6px !important;
  height: ${({ height }) => height || '24px'};
  font-family: 'Rubik', sans-serif;
  width: ${({ block }) => (block ? '100%' : 'auto')};

  transition: all 0.3s ease;

  &:hover {
    opacity: 0.95;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

/* == Rounded Select == */
export const RoundedSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 6px !important;
    height: ${({ height }) => height || '32px'} !important;
    font-family: 'Rubik', sans-serif;
    display: flex;
    align-items: center;
  }

  &:hover .ant-select-selector,
  &.ant-select-focused .ant-select-selector {
    border-color: #1890ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  &.ant-select-disabled .ant-select-selector {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

/* == Rounded DatePicker == */
export const RoundedDatePicker = styled(DatePicker)`
  border-radius: 6px !important;
  height: ${({ height }) => height || '32px'} !important;
  font-family: 'Rubik', sans-serif;
  width: 100%;

  &:hover,
  &:focus {
    border-color: #1890ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  &.ant-picker-disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

/* == Rounded Tag == */
export const RoundedTag = styled(Tag)`
  && {
    border-radius: 6px;
    font-family: 'Rubik', sans-serif;
    padding: 0 8px;
    height: ${({ height }) => height || '24px'};
    line-height: ${({ height }) => height || '24px'};
    display: inline-flex;
    align-items: center;
    transition: all 0.3s ease;
  }

  &&:hover {
    opacity: 0.95;
  }

  &&.ant-tag-disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ScrollableCol = styled(Col)`
  overflow: auto;
  max-height: calc(200vh - 300px);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;
